import { ModelSetTransformer, ModelTransformer } from '../common/common.model';
import { Util } from '../common/common.util';

export interface ExtPersonalScorecardChartItem {
    monthInitials: string;
    monthStartDate: string;
    monthEndDate: string;
    scoreCardId: number;
    personalScore: number;
    peersScore: number;
}

export interface PersonalScorecardChartItem {
    monthInitials: string;
    startDate: Date;
    endDate: Date;
    scorecardId: number;
    personalScore: number;
    peersScore: number;
}

export interface PersonalScorecardChart {
    items: PersonalScorecardChartItem[];
    d3: { options?: any; data: any };
}

class PersonalScorecardChartItemModelTransformer
    implements
        ModelTransformer<
            PersonalScorecardChartItem,
            ExtPersonalScorecardChartItem
        >
{
    transform(
        model: ExtPersonalScorecardChartItem,
    ): PersonalScorecardChartItem {
        return {
            monthInitials: model.monthInitials,
            startDate: Util.dateToDate(model.monthStartDate),
            endDate: Util.dateToDate(model.monthEndDate),
            scorecardId: model.scoreCardId,
            personalScore: model.personalScore,
            peersScore: model.peersScore,
        };
    }
}

class PersonalScorecardChartItemModelSetTransformer extends ModelSetTransformer<
    PersonalScorecardChartItem,
    ExtPersonalScorecardChartItem
> {
    protected newTransformer(): ModelTransformer<
        PersonalScorecardChartItem,
        ExtPersonalScorecardChartItem
    > {
        return new PersonalScorecardChartItemModelTransformer();
    }
}

export class PersonalScorecardChartModelTransformer
    implements
        ModelTransformer<
            PersonalScorecardChart,
            ExtPersonalScorecardChartItem[]
        >
{
    transform(model: ExtPersonalScorecardChartItem[]): PersonalScorecardChart {
        const items =
            new PersonalScorecardChartItemModelSetTransformer().transform(
                model,
            );
        const data = [
            {
                key: null,
                color: '#3fa9f5',
                values: null,
            },
            {
                key: null,
                color: '#d9d9d9',
                values: null,
            },
        ];
        data.forEach((value, index) => {
            value.values = items.map((item) => {
                return {
                    x: item.monthInitials,
                    y: index === 0 ? item.personalScore : item.peersScore,
                };
            });
        });
        return {
            items,
            d3: {
                options: {
                    yDomain: [
                        0,
                        data.reduce(
                            (a, value) =>
                                Math.max(
                                    a,
                                    value.values.reduce((a2, value2) =>
                                        Math.max(a, value2.y),
                                    ),
                                ),
                            0,
                        ),
                    ],
                },
                data,
            },
        };
    }
}

export function validatePersonalScorecardChart(
    model: PersonalScorecardChart,
): void {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const valid =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        model != null &&
        model.items != null &&
        model.items.length !== 0 &&
        model.d3.data.find(
            (value) => value.values == null || value.values.length === 0,
        ) == null;
    if (!valid) {
        throw new Error('PersonalScorecardChart not valid');
    }
}
